import { Fragment } from 'react';

import { FeedbackTextInput } from './FeedbackTextInput';
import { NewSkillTitleInput } from './NewSkillTitleInput';
import { SkillTypeSelector } from './SkillTypeSelector';
import { useFeedbackDialogStore } from './use-feedback-dialog-store';

import type { ChangeSkillFormState, ReportSkillFormState, RequestSkillFormState } from './feedback-dialog-store';
import type { SkillType } from '../../../shared/source/data-contract/skill';
import type { FunctionComponent } from 'react';

type RequestSkillTabContentProps = {
    readonly descriptionValue: string;
    readonly onDescriptionChange: (input: string) => void;
};

const isRequestSkillFormState = (
    formState: ChangeSkillFormState | ReportSkillFormState | RequestSkillFormState,
): formState is RequestSkillFormState => 'title' in formState;

export const RequestSkillTabContent: FunctionComponent<RequestSkillTabContentProps> = ({
    descriptionValue,
    onDescriptionChange,
}) => {
    const createSkillDescriptionLabel = useFeedbackDialogStore((state) => state.createSkillDescriptionLabel);
    const createSkillPlaceholderLabel = useFeedbackDialogStore((state) => state.createSkillPlaceholderLabel);
    const createSkillTitleLabel = useFeedbackDialogStore((state) => state.createSkillTitleLabel);
    const requestNewSkillTitlePlaceholderLabel = useFeedbackDialogStore(
        (state) => state.requestNewSkillTitlePlaceholderLabel,
    );

    const setFeedbackInformation = useFeedbackDialogStore((state) => state.setFeedbackInformation);
    const currentFeedbackType = useFeedbackDialogStore((state) => state.currentFeedbackType);
    const feedback = useFeedbackDialogStore((state) => state.feedback);

    const skillTitleValue = feedback[currentFeedbackType].mapOr('', (formState) => {
        return isRequestSkillFormState(formState) ? formState.title.value.unwrapOr('') : '';
    });

    const onSkillTitleChange = (input: string): void => {
        setFeedbackInformation({
            title: input,
        });
    };
    const setFeedbackSkillType = (type: SkillType): void => {
        setFeedbackInformation({
            type,
        });
    };

    const selectedType = feedback.request.andThen((req) => req.type);

    return (
        <Fragment>
            <NewSkillTitleInput
                placeholder={requestNewSkillTitlePlaceholderLabel}
                required={true}
                title={createSkillTitleLabel}
                value={skillTitleValue}
                onChange={onSkillTitleChange}
            />
            <FeedbackTextInput
                placeholder={createSkillPlaceholderLabel}
                required={true}
                title={createSkillDescriptionLabel}
                value={descriptionValue}
                onChange={onDescriptionChange}
            />
            <SkillTypeSelector selectedType={selectedType} onSkillTypeSelected={setFeedbackSkillType} />
        </Fragment>
    );
};
